module.exports = __webpack_public_path__ + "img/weibo.d68a8933.svg";